import React, { lazy, Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import Page from "./components/Page";
import ErrorBoundary from "./components/ErrorBoundary";
import LoadingFallback from "./components/LoadingFallback";
import "react-lazy-load-image-component/src/effects/blur.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "yet-another-react-lightbox/styles.css";
import "aos/dist/aos.css";
import { CookiesProvider } from "react-cookie";

const target = import.meta.env.VITE_TARGET;

let Routes;
if (target === "web") {
  Routes = lazy(() => import("web/web.router"));
} else if (target === "portal") {
  Routes = lazy(() => import("portal/portal.router"));
} else if (target === "profile") {
  Routes = lazy(() => import("profile/profile.router"));
} else if (target === "office") {
  Routes = lazy(() => import("office/office.router"));
} else if (target === "xcom") {
  Routes = lazy(() => import("xcom/xcom.router"));
} else if (target === "admin") {
  Routes = lazy(() => import("admin/admin.router"));
}

const App: React.FC = (): JSX.Element => {
  return (
    <ErrorBoundary>
      <Page>
        <BrowserRouter>
          <Suspense fallback={<LoadingFallback />}>
            <CookiesProvider>
              <ErrorBoundary>
                <Routes />
              </ErrorBoundary>
            </CookiesProvider>
          </Suspense>
        </BrowserRouter>
      </Page>
    </ErrorBoundary>
  );
};

export default App;
